<template>
	<div class="w-file-uploader">
		<div class="form-group">
			<label for="name">{{ label }}</label>
			<div class="progress mb-3" v-if="loading">

				<div class="progress-bar progress-bar-striped progress-bar-animated"
					role="progressbar"
					:style="'width:' + percent + '%'"
					:aria-valuenow="percent + '%'"
					aria-valuemin="0"
					aria-valuemax="100"
				></div>

			</div>
			<div class="upload-drop placeholder" v-if="!loading" ref="droparea">
					<div class="file-selector">Перетащите файл в это поле или
						<a href="#">выбрать с компьютера
							<input type="file" :accept="$_accept" ref="file" :multiple="false" @change="handleFileUpload" >
						</a>
					</div>
			</div>
			<ul class="uploaded-items" v-if="uploadedItems.length > 0">
				<li v-for="(item, key) in uploadedItems" :key="key" :data-file-id="item.id">
					<span class="filename">{{ item.origName }}</span>
					<span class="remove-btn">
						<button class="btn btn-sm btn-danger" type="button" @click="handleRemoveItem(item.id)">
							<i class="icon-trash icons d-block"></i>
						</button>
					</span>
				</li>
			</ul>
		</div>
	</div>
</template>
<script>
import FileUpload from 'vue-upload-component'
export default {
	components: {
		FileUpload
	},
	data () {
		return {
			loading: false,
			percent: 0,
			file: null,
			$_accept: '',
			uploadedItems: []
		}
	},
	props: {
		typeId: {
			type: Number,
			required: true
		},
		data: {
			type: Array,
			required: true
		},
		label: {
			type: String,
			default: 'Тест'
		},
		accept: {
			type: Array,
			default: () => {
				return []
			}
		}
	},
	created () {
		this.$_accept = this.accept.splice(', ')
		this.data.forEach((value, key) => {
			if (parseInt(value.type_id) === this.typeId) {
				const data = {
					id: value.id,
					origName: value.orig_name
				}
				this.uploadedItems.push(data)
			}
		})
	},
	mounted () {
		this.dragInit()
	},
	methods: {
		handleFileUpload () {
			const file = this.$refs.file.files[0]
			this.upload(file)
		},
		upload (file) {
			let formData = new FormData()
			formData.append('file', file)

			this.toggleLoading()
			this.$http.post(this.$store.state.apiURL + '/v1/file/uploads?type_id=' + this.typeId, formData, {
				headers: {'Content-Type': 'multipart/form-data'},
				uploadProgress: (e) => {
					this.percent = (e.loaded / e.total) * 100
				}
			}).then((response) => {
				const data = response.body
				this.resetUploadedItems()
				this.uploadedItems.push({
					id: data.id,
					name: data.name,
					origName: data.orig_name,
					size: data.size
				})
				this.$emit('upload', {typeId: this.typeId, id: data.id})
				this.toggleLoading()
			}, (response) => {
				this.toggleLoading()
			})
		},
		handleRemoveItem (id) {
			this.resetUploadedItems()
			this.$emit('remove', {id: id, typeId: this.typeId})
		},
		resetUploadedItems () {
			this.uploadedItems = []
		},
		toggleLoading () {
			this.loading = !this.loading
		},
		dragInit () {
			;['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
				this.$refs.droparea.addEventListener(eventName, (e) => {
					e.preventDefault()
					e.stopPropagation()
				}, false)
			})
			;['dragenter', 'dragover'].forEach(eventName => {
				this.$refs.droparea.addEventListener(eventName, this.highlight, false)
			})
			;['dragleave', 'drop'].forEach(eventName => {
				this.$refs.droparea.addEventListener(eventName, this.unhighlight, false)
			})
			this.$refs.droparea.addEventListener('drop', this.handleDrop, false)
		},
		highlight () {
			this.$refs.droparea.closest('.w-file-uploader').classList.add('active')
		},
		unhighlight () {
			this.$refs.droparea.closest('.w-file-uploader').classList.remove('active')
		},
		handleDrop (e) {
			let dt = e.dataTransfer
			let file = dt.files[0]
			this.upload(file)
		}
	}
}
</script>
<style lang="scss">
@import "~@coreui/coreui/scss/coreui";
.w-file-uploader {
	.upload-drop {
		.file-selector {
			display: flex;
			margin: 0 !important;
		}
		a {
			display: inline-block;
			margin-left: 0.25rem;
			position: relative;
			overflow: hidden;
			color: $link-color;
			cursor: pointer;
			input[type="file"] {
				position: absolute;
				top: 0;
				z-index: 1;
				width: 100%;
				opacity: 0;
				cursor: pointer;
				left: 0;
				font-size: 500px;
			}
		}
	}
	.placeholder {
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 15px;
		padding: 15px;
		border: 1px dashed #E5E5E5;
		background: #fafafa;
		color: #666;
		&.active {
			border-color: #ff0000;
		}
	}
	.uploaded-items {
		padding: 0;
		margin: 0;
		list-style: none;
		li {
			display: flex;
			flex-wrap: wrap;
			background: #f1f1f1;
			padding: 0.5em 1em;
			font-weight: bold;
			.filename {
				padding: 0.2em 0;
			}
			.remove-btn {
				display: flex;
				margin-left: auto;
			}
		}
	}
	&.active {
		.upload-drop {
			border-color: $link-color;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/components/form/file-upload.vue